import PropTypes from "prop-types"
import { FormControl, FormHelperText, InputLabel, NativeSelect, OutlinedInput, Select } from "@mui/material"

const DropdownCommon = ({
  disabled,
  error,
  label,
  multiple,
  native,
  name,
  onChange,
  renderOptions,
  required,
  value,
  ...rest
}) => {
  const labelId = `${name}-label`
  const selectId = `${name}-select`

  return (
    <FormControl disabled={disabled} error={!!error} fullWidth size="small">
      <InputLabel id={labelId} required={required}>
        {label}
      </InputLabel>

      {native ? (
        <NativeSelect
          {...rest}
          id={selectId}
          inputProps={{
            id: selectId,
            name,
          }}
          name={name}
          onChange={onChange}
          required={required}
          value={value ?? ""}
        >
          {renderOptions}
        </NativeSelect>
      ) : (
        <Select
          {...rest}
          error={!!error}
          id={selectId}
          input={<OutlinedInput label={label} />}
          label={label}
          labelId={labelId}
          MenuProps={{ disablePortal: true, disableScrollLock: true }}
          multiple={!!multiple}
          name={name}
          onChange={onChange}
          required={required}
          value={value ?? (multiple ? [] : "")}
        >
          {renderOptions}
        </Select>
      )}

      <FormHelperText className={name}>
        {error?.message || ""}
      </FormHelperText>
    </FormControl>
  )
}

DropdownCommon.propTypes = {
  disabled: PropTypes.bool,
  error: PropTypes.object,
  label: PropTypes.string.isRequired,
  multiple: PropTypes.bool,
  native: PropTypes.bool,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  renderOptions: PropTypes.array.isRequired,
  required: PropTypes.bool,
  value: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.string
  ])
}

export default DropdownCommon